class ModalDialog extends HTMLElement {
  constructor() {
    super();

    const context = this;
    const closeButton = this.querySelector('[data-dialog-close]');

    this.id = this.getAttribute('id');

    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        context.hide();
      });
    }

    this.addEventListener('keyup', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') this.hide();
    });

    this.addEventListener('click', function (e) {
      if (e.target === e.currentTarget) {
        context.hide();
      }
    });
  }

  show(context) {
    this.openedBy = context;

    this.classList.remove('dialog-close');
    this.setAttribute('aria-hidden', false);
    document.documentElement.classList.add('overflow-hidden');

    if (context) {
      context.setAttribute('aria-expanded', true);
    }
  }

  hide(context) {
    this.classList.add('dialog-close');

    if (this.openedBy) {
      this.openedBy.setAttribute('aria-expanded', false);
    }

    setTimeout(() => {
      this.setAttribute('aria-hidden', true);
      document.documentElement.classList.remove('overflow-hidden');
    }, 300);
  }
}

customElements.define('modal-dialog', ModalDialog);

class DialogTrigger extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const dialogId = this.getAttribute('aria-controls');
      if (!dialogId) return;

      const dialog = document.getElementById(dialogId);
      if (dialog) {
        dialog.show(this);
      }
    });
  }
}

customElements.define('dialog-trigger', DialogTrigger);
